import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Import required modules
import { Autoplay, Pagination } from "swiper/modules";


// Import your custom CSS file
import "../../styles/employeeDetails.css"; 

const Testimonials = () => {
  // 10 Static Data Items
  const testimonialsData = [
    {
      id: 1,
      text: "I cleared CA Inter in my first attempt thanks to Madhi Academy's personal guidance.",
      name: "KARTHIK R",
      role: "CA Student",
      rating: 5,
    },
    {
      id: 2,
      text: "The recorded classes and daily doubt-solving sessions made CMA Inter easy for me.",
      name: "PRIYA M",
      role: "CMA Student",
      rating: 5,
    },
    {
      id: 3,
      text: "CS training here is very practical and industry-oriented. Best place for students.",
      name: "VIGNESH S",
      role: "CS Student",
      rating: 5,
    },
    {
      id: 4,
      text: "The faculty is extremely experienced. They made complex accounting concepts simple.",
      name: "ANITHA K",
      role: "CA Foundation",
      rating: 4,
    },
    {
      id: 5,
      text: "Madhi Academy provided the best study materials for my CMA preparation.",
      name: "RAHUL V",
      role: "CMA Final",
      rating: 5,
    },
    {
      id: 6,
      text: "Professional environment and supportive staff. Highly recommend for commerce students.",
      name: "SNEHA P",
      role: "B.Com Student",
      rating: 5,
    },
    {
      id: 7,
      text: "I failed twice before joining here. Their test series helped me pass with distinction.",
      name: "ARJUN D",
      role: "CA Inter",
      rating: 5,
    },
    {
      id: 8,
      text: "Great infrastructure and library facilities. It helped me focus on my studies.",
      name: "LAKSHMI N",
      role: "CS Executive",
      rating: 4,
    },
    {
      id: 9,
      text: "The conceptual clarity I got here helped me secure a job in a Big 4 firm.",
      name: "DINESH K",
      role: "Global Professional",
      rating: 5,
    },
    {
      id: 10,
      text: "Affordable fees with high-quality coaching. Best decision for my career.",
      name: "MEERA S",
      role: "Skill Training",
      rating: 5,
    },
  ];

  // Helper function to render stars dynamically
  const renderStars = (count) => {
    return Array(count)
      .fill(0)
      .map((_, i) => <span key={i} className="star">★</span>);
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <Swiper
          spaceBetween={30}
          slidesPerView={1} // Mobile default: 1 card
          loop={true} // Infinite loop
          grabCursor={true} // Allows dragging with mouse
          autoplay={{
            delay: 10000, // 10 Seconds delay
            disableOnInteraction: false,
          }}
          breakpoints={{
            // When window width is >= 768px (Tablet)
            768: {
              slidesPerView: 2,
            },
            // When window width is >= 992px (Desktop)
            992: {
              slidesPerView: 3, // Show 3 cards
            },
          }}
          modules={[Autoplay, Pagination]}
          className="testimonials-swiper"
        >
          {testimonialsData.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="testimonial-card-wrapper">
                
                {/* 1. The White Quote Box */}
                <div className="quote-box">
                  <p className="quote-text">
                    "{item.text}"
                  </p>
                  
                  {/* Floating Icon Container (Absolute Position) */}
                  <div className="profile-wrapper">
                    <div className="profile-circle">
                      <i className="bi bi-person-fill profile-icon"></i>
                    </div>
                  </div>
                </div>

                {/* 2. Info Below (Stars, Name, Role) */}
                <div className="student-info">
                  <div className="rating-stars">
                    {renderStars(item.rating)}
                  </div>
                  <h4 className="student-name">{item.name}</h4>
                  <span className="student-role">{item.role}</span>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;